import { Navigate, useLocation } from "react-router-dom";
import { ATTENDANCE_CALENDAR_MASTER_PATH } from "./attendanceCalendarMasterConfig";

/** Redirect legacy attendance sub-routes into the master calendar hub. */
export function RedirectToAttendanceCalendarMaster({ tab }) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  if (tab && tab !== "daily") params.set("tab", tab);
  else if (tab === "daily") params.delete("tab");
  const qs = params.toString();
  const to = qs ? `${ATTENDANCE_CALENDAR_MASTER_PATH}?${qs}` : ATTENDANCE_CALENDAR_MASTER_PATH;
  return <Navigate to={to} replace />;
}
